import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import styles from './dropdown-list.scss';

export default class DropdownList extends React.Component {
  constructor() {
    super();

    this.setListRef = this.setListRef.bind(this);
  }

  componentDidUpdate(prevProps) {
    const newItems = _.flatten(this.props.children) > _.flatten(prevProps.children);
    if (this.props.allowTopScroll && this._list && newItems) {
      this._list.scrollTop = 0;
    }
  }

  setListRef(el) {
    this._list = el;
  }

  render() {
    if (this.props.open === true) {
      const className = classnames('dropdown-drop', 'dropdown-results', 'open', {
        [styles.open]: this.props.open,
        [styles.wide]: this.props.wide,
        [styles.openRight]: this.props.openRight,
      });

      return (
        <div ref={this.setListRef} className={className} onMouseDown={this.props.onMouseDown}>
          {this.props.children}
        </div>
      );
    }

    return null;
  }
}

DropdownList.propTypes = {
  onMouseDown: React.PropTypes.func,
  open: React.PropTypes.bool,
  children: React.PropTypes.any,
  allowTopScroll: React.PropTypes.bool,
  wide: React.PropTypes.bool,
  openRight: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-list.jsx